import { gql } from '@apollo/client'

import { STORE_FRAGMENT } from '../fragments'

export const GET_ALL_TENANT_STORES = gql`
  query GetAllTenantStores(
    $filters: StoreFilter
    $order: StoreOrder
    $pagination: OffsetPaginationInput
  ) {
    allTenantStores(filters: $filters, order: $order, pagination: $pagination) {
      results {
        ...Store
      }
      pageInfo {
        limit
        offset
      }
      totalCount
    }
  }
  ${STORE_FRAGMENT}
`
